import { useNavigate } from 'react-router-dom';
import type { AssetItem } from '@/mocks/profile';

interface Props {
  assets: AssetItem[];
}

export default function AssetCards({ assets }: Props) {
  const navigate = useNavigate();

  const handleCardClick = (item: AssetItem) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <div className="mt-1">
      {/* Title */}
      <div className="flex items-center justify-between mb-1">
        <span className="text-foreground-900 font-bold text-sm">我的资产</span>
      </div>

      <div className="grid grid-cols-2 gap-2.5">
        {assets.map((item) => {
          const isGold = item.variant === 'gold';
          return (
            <div
              key={item.id}
              onClick={() => handleCardClick(item)}
              className={`rounded-2xl p-4 relative overflow-hidden group cursor-pointer active:scale-[0.98] transition-transform ${
                isGold
                  ? 'bg-gradient-to-br from-secondary-50 to-secondary-100 border border-secondary-200/40'
                  : 'bg-gradient-to-br from-accent-50 to-accent-100 border border-accent-200/40'
              }`}
            >
              {/* Decorative circles */}
              <div className={`absolute -top-6 -right-6 w-20 h-20 rounded-full opacity-15 ${
                isGold ? 'bg-secondary-400' : 'bg-accent-400'
              }`} />
              <div className={`absolute -bottom-4 -left-4 w-12 h-12 rounded-full opacity-10 ${
                isGold ? 'bg-secondary-400' : 'bg-accent-400'
              }`} />

              <div className="relative z-10">
                {/* Label */}
                <div className="flex items-center gap-1.5 mb-2">
                  <div className={`w-6 h-6 rounded-md flex items-center justify-center ${
                    isGold
                      ? 'bg-secondary-200/50 text-secondary-600'
                      : 'bg-accent-200/50 text-accent-600'
                  }`}>
                    <i className={`${item.icon} text-xs`} />
                  </div>
                  <span className={`text-xs font-medium ${
                    isGold ? 'text-secondary-700' : 'text-accent-700'
                  }`}>
                    {item.label}
                  </span>
                </div>

                {/* Amount */}
                <p className={`text-xl font-bold tracking-tight ${
                  isGold ? 'text-secondary-800' : 'text-accent-800'
                }`}>
                  {item.amount}
                </p>

                {item.subLabel && (
                  <p className={`text-[10px] mt-1.5 ${
                    isGold ? 'text-secondary-500/80' : 'text-accent-500/80'
                  }`}>
                    {item.subLabel}
                  </p>
                )}
              </div>

              {/* Hover arrow */}
              <div className={`absolute right-3 top-3 opacity-0 group-hover:opacity-30 transition-opacity ${
                isGold ? 'text-secondary-400' : 'text-accent-400'
              }`}>
                <i className="ri-arrow-right-up-line text-base" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}